var _defs, _path, _path2, _path3, _path4, _rect, _path5, _path6, _g, _g2, _path7, _rect2, _path8, _path9, _path10, _path11, _g3, _g4, _path12, _rect3, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _rect4, _path26, _path27, _path28, _path29, _path30;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinishProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158.356,
    height: 148.024,
    viewBox: "0 0 158.356 148.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1767",
    "data-name": "Rectangle 1767",
    width: 57.276,
    height: 1.527
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1769",
    "data-name": "Rectangle 1769",
    width: 26.128,
    height: 3.012
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1773",
    "data-name": "Rectangle 1773",
    width: 33.387,
    height: 4.533,
    fill: "#699dee"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1774",
    "data-name": "Rectangle 1774",
    width: 22.829,
    height: 1.994,
    fill: "#699dee"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12767",
    "data-name": "Group 12767",
    transform: "translate(-587.311 -461.002)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10823",
    "data-name": "Path 10823",
    d: "M130.463,349.651c0,2.781-29.205,5.035-65.232,5.035S0,352.432,0,349.651s29.205-5.035,65.232-5.035,65.232,2.255,65.232,5.035",
    transform: "translate(601.258 254.34)",
    fill: "#7586ec",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10786",
    "data-name": "Path 10786",
    d: "M2267.809,938.857h-5.431a1,1,0,1,1,0-1.994h5.431a1,1,0,0,1,0,1.994",
    transform: "translate(-1525.233 -388.785)",
    fill: "#9bc1f9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10787",
    "data-name": "Path 10787",
    d: "M1328.39,0h-10.685a5.548,5.548,0,1,0,0,11.1h10.685a5.548,5.548,0,1,0,0-11.1",
    transform: "translate(-656.436 461.701)",
    fill: "#1e2849"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10788",
    "data-name": "Path 10788",
    d: "M1103.683,1343.341l-16.328,7.757v1.718h58.151V1351.1l-16.476-7.757Z",
    transform: "translate(-449.692 -756.186)",
    fill: "#040227"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1764",
    "data-name": "Rectangle 1764",
    width: 26.138,
    height: 46.178,
    transform: "translate(653.862 541.885)",
    fill: "#040227"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10789",
    "data-name": "Path 10789",
    d: "M663.119,152.947v-83.5a3.835,3.835,0,0,0-3.692-3.963H508.455a3.835,3.835,0,0,0-3.692,3.963v83.5Z",
    transform: "translate(82.548 402.768)",
    fill: "#1e2849"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10822",
    "data-name": "Path 10822",
    d: "M0,0H149.988V68.4H0Z",
    transform: "translate(590.196 484.43)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9698",
    "data-name": "Group 9698",
    transform: "translate(638.539 595.104)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9697",
    "data-name": "Group 9697",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9696",
    "data-name": "Group 9696",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1766",
    "data-name": "Rectangle 1766",
    width: 57.275,
    height: 1.527,
    transform: "translate(0)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9701",
    "data-name": "Group 9701",
    transform: "translate(654.007 584.145)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9700",
    "data-name": "Group 9700",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9699",
    "data-name": "Group 9699",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1768",
    "data-name": "Rectangle 1768",
    width: 26.128,
    height: 3.012,
    transform: "translate(0)"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10815",
    "data-name": "Path 10815",
    d: "M0,0H37.34V75.359H0Z",
    transform: "translate(704.763 477.471)",
    fill: "#d2e4fd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1771",
    "data-name": "Rectangle 1771",
    width: 151.906,
    height: 6.959,
    transform: "translate(590.196 477.471)",
    fill: "#040227"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10790",
    "data-name": "Path 10790",
    d: "M504.763,1027.006v12.021c0,2.5,1.653,4.527,3.692,4.527H659.427c2.039,0,3.692-2.027,3.692-4.527v-12.021Z",
    transform: "translate(82.548 -471.291)",
    fill: "#040227"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10791",
    "data-name": "Path 10791",
    d: "M567.228,132.459a1.209,1.209,0,1,1-1.209-1.209,1.209,1.209,0,0,1,1.209,1.209",
    transform: "translate(27.59 348.568)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10792",
    "data-name": "Path 10792",
    d: "M617.69,132.459a1.209,1.209,0,1,1-1.209-1.209,1.209,1.209,0,0,1,1.209,1.209",
    transform: "translate(-18.598 348.568)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10793",
    "data-name": "Path 10793",
    d: "M668.155,132.459a1.209,1.209,0,1,1-1.209-1.209,1.209,1.209,0,0,1,1.209,1.209",
    transform: "translate(-64.786 348.568)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9704",
    "data-name": "Group 9704",
    transform: "translate(706.718 541.885)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9703",
    "data-name": "Group 9703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9702",
    "data-name": "Group 9702",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10794",
    "data-name": "Path 10794",
    d: "M1945.757,868.321h-30.042a1.674,1.674,0,0,1-1.673-1.672V865.46a1.675,1.675,0,0,1,1.673-1.672h30.042a1.675,1.675,0,0,1,1.673,1.672v1.188a1.674,1.674,0,0,1-1.673,1.672m-30.042-4.2a1.342,1.342,0,0,0-1.34,1.34v1.188a1.342,1.342,0,0,0,1.34,1.34h30.042a1.342,1.342,0,0,0,1.34-1.34V865.46a1.341,1.341,0,0,0-1.34-1.34Z",
    transform: "translate(-1914.043 -863.788)",
    fill: "#699dee"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9707",
    "data-name": "Group 9707",
    transform: "translate(706.884 548.078)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9706",
    "data-name": "Group 9706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9705",
    "data-name": "Group 9705",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10795",
    "data-name": "Path 10795",
    d: "M1937.835,938.857H1917a1,1,0,1,1,0-1.994h20.834a1,1,0,0,1,0,1.994",
    transform: "translate(-1916.003 -936.863)",
    fill: "#699dee"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10796",
    "data-name": "Path 10796",
    d: "M1427.784,18.9a1.47,1.47,0,1,1-1.47-1.47,1.47,1.47,0,0,1,1.47,1.47",
    transform: "translate(-759.575 445.748)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1775",
    "data-name": "Rectangle 1775",
    width: 110.866,
    height: 66.28,
    transform: "translate(591.22 485.227)",
    fill: "#d2e4fd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10816",
    "data-name": "Path 10816",
    d: "M0,0H158.356V148.023H0Z",
    transform: "translate(587.312 461.002)",
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10797",
    "data-name": "Path 10797",
    d: "M917.479,285.339a24.765,24.765,0,0,0-3.05-11.758c-1.788-3.164-5.8-4.76-9.343-4.528-11.255.735-11.7,15.7-18.478,21.911-2.072,1.9-4.424,3.488-6.369,5.516-7.183,7.488-2.878,20.177,4.552,25.827,5.156,3.921,12.976,5.824,18.762,2.1a18.931,18.931,0,0,0,6.694-8.248c2.108-4.638,3.316-9.909,4.709-14.8a53.917,53.917,0,0,0,2.522-16.03",
    transform: "translate(-257.745 222.461)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10798",
    "data-name": "Path 10798",
    d: "M1024.658,616.935s-10.16,1.075-12.853,3.917l7.044,26.568h20.529s4.048-20.354,0-27.384c-1.351-2.343-7.508-2.438-7.508-2.438Z",
    transform: "translate(-381.533 -95.967)",
    fill: "#699dee"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10799",
    "data-name": "Path 10799",
    d: "M1451.81,349.373c-.375-.793-3.715,1.554-4.455,1.108s2.992-4.21,2.611-4.868c-.7-1.212-4.342,3.87-4.7,3.333s3.137-5.962,1.889-6.261-3.037,6-3.678,5.6,2.192-5.711.983-6.793c-.646-.578-3.691,9.681-4.795,10.108s-2.348-4.053-3.388-3.877,3.409,8.238,3.191,8.868-4.291,13.79-6.7,17.766c-1.447-.692-2.856-1.388-4.2-2.066-.54,3.053-1.786,5.719-2.5,8.716,4.666,2.05,10.015,4.085,11.37,3.586,4.126-1.519,6.161-21.547,6.823-25.284s2.427-4.474,3.432-6.437,4.482-2.7,4.107-3.5",
    transform: "translate(-760.705 156.162)",
    fill: "#ffb27d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10800",
    "data-name": "Path 10800",
    d: "M1247.758,637.867l-6,7.188a124.909,124.909,0,0,0,16.335,9.2c.709-3,2.459-7.694,3-10.747a124.665,124.665,0,0,0-13.338-5.637",
    transform: "translate(-592.005 -115.125)",
    fill: "#699dee"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10801",
    "data-name": "Path 10801",
    d: "M662.438,347.335c.375-.793,3.715,1.555,4.456,1.108s-2.992-4.21-2.612-4.868c.7-1.212,4.341,3.87,4.7,3.333s-3.137-5.962-1.889-6.261,3.038,6,3.678,5.6-2.191-5.711-.983-6.793c.646-.578,3.69,9.681,4.795,10.108s2.348-4.053,3.388-3.877-3.409,8.238-3.191,8.868,4.291,13.79,6.7,17.766c1.447-.692,2.856-1.388,4.2-2.066.54,3.053,1.987,5.944,2.7,8.941-4.666,2.05-10.216,3.86-11.571,3.361-4.126-1.519-6.161-21.547-6.823-25.284s-2.427-4.474-3.432-6.437-4.482-2.7-4.107-3.5",
    transform: "translate(-61.742 158.027)",
    fill: "#ffb27d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10802",
    "data-name": "Path 10802",
    d: "M937.071,630.479l1.084,16.267s-4.184-3.394-11.922.006c-.709-3-2.459-7.694-3-10.747a103.016,103.016,0,0,1,13.837-5.526",
    transform: "translate(-300.467 -108.363)",
    fill: "#699dee"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10803",
    "data-name": "Path 10803",
    d: "M1146.865,485.379s-.025.228-.07.617c-.22,1.864-1.13,8.058-1.909,9.8-.94,2.1,4.248,8.255,8.775,7.16,1.347-.326-1.548-5.869-1.467-6.482.154-1.173.363-2.774.576-4.415.12-.926.242-1.865.356-2.747.325-2.507.59-4.558.59-4.558Z",
    transform: "translate(-503.236 25.018)",
    fill: "#ffb27d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10804",
    "data-name": "Path 10804",
    d: "M1164.541,503.5c.046-.388.071-.616.071-.616l6.85-.628s-.265,2.051-.59,4.558c-.114.877-.234,1.81-.354,2.731a6.446,6.446,0,0,1-3.385-1.421,8.777,8.777,0,0,1-2.757-3.532c.056-.438.132-.8.166-1.092",
    transform: "translate(-521.175 9)",
    fill: "#ed985f"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10805",
    "data-name": "Path 10805",
    d: "M1134.242,306.141a6.581,6.581,0,0,0-5.421,2.751c-1.965,2.918-3.711,11.653,1.94,15.963s10.576-1.323,10.985-6.974.262-12.46-7.5-11.74",
    transform: "translate(-486.907 188.543)",
    fill: "#ffb27d"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10806",
    "data-name": "Path 10806",
    d: "M1288.868,410.349c-.555,1.279-1.579,2.035-2.288,1.689s-.833-1.664-.277-2.943,1.579-2.035,2.288-1.689.833,1.664.278,2.944",
    transform: "translate(-632.455 95.887)",
    fill: "#ffb27d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10807",
    "data-name": "Path 10807",
    d: "M1101.554,295.376s-4.039,8.465-7.291,9.061-3.394,4.96-3.394,4.96.506-10.069,3.623-12.212a12.1,12.1,0,0,1,7.062-1.808",
    transform: "translate(-453.897 198.365)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10808",
    "data-name": "Path 10808",
    d: "M1105.521,402.538c.363,1.431-.085,2.8-1,3.048s-1.952-.7-2.315-2.135.085-2.8,1-3.048,1.952.7,2.315,2.136",
    transform: "translate(-464.16 102.256)",
    fill: "#ffb27d"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1777",
    "data-name": "Rectangle 1777",
    width: 110.866,
    height: 66.28,
    transform: "translate(590.672 485.225)",
    fill: "none"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10819",
    "data-name": "Path 10819",
    d: "M425.856,1059.347a.736.736,0,0,1,.728-.744l9.08-.1.164,0,9.08-.1a.736.736,0,0,1,.744.728l.024,2.209-9.9-.513-9.891.731Z",
    transform: "translate(179.635 -480.947)",
    fill: "#040227"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10817",
    "data-name": "Path 10817",
    d: "M424.878,1142.027l.163,0,9.128-.1a1.716,1.716,0,0,1,1.733,1.811l-1.2,21.77a1.714,1.714,0,0,1-1.226,1.551,37.064,37.064,0,0,1-8.29.756,35.922,35.922,0,0,1-8.194-.575,1.713,1.713,0,0,1-1.26-1.524l-1.677-21.739a1.717,1.717,0,0,1,1.693-1.848Z",
    transform: "translate(190.688 -558.793)",
    fill: "#699dee"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10818",
    "data-name": "Path 10818",
    d: "M397.718,1088.968a1.744,1.744,0,0,1,1.512-1.472l9.831-.108.164,0,9.831-.108a1.745,1.745,0,0,1,1.544,1.439l.828,2.909a1.287,1.287,0,0,1-1.224,1.639l-10.913.12-.164,0-10.913.12a1.287,1.287,0,0,1-1.259-1.612Z",
    transform: "translate(206.458 -508.514)",
    fill: "#040227"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10820",
    "data-name": "Path 10820",
    d: "M431.406,1209.333l-.722,9.9a.4.4,0,0,1-.29.357,40.063,40.063,0,0,1-20.564.226.4.4,0,0,1-.3-.351l-.939-9.88a.4.4,0,0,1,.476-.432c4.863.969,17.011.836,21.851-.24a.4.4,0,0,1,.485.422",
    transform: "translate(195.711 -620.412)",
    fill: "#040227"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10821",
    "data-name": "Path 10821",
    d: "M512.984,1241.953a3.936,3.936,0,1,0,4.581-3.163,3.936,3.936,0,0,0-4.581,3.163",
    transform: "translate(99.729 -647.85)",
    fill: "#f3fdff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishProfile);
export default __webpack_public_path__ + "static/media/finish-profile.f5bdf389f8c2e8b8d774fc2faeef26ca.svg";
export { ForwardRef as ReactComponent };